import { render, staticRenderFns } from "./todoDetailsTrusteeship.vue?vue&type=template&id=3072755d&"
import script from "./todoDetailsTrusteeship.vue?vue&type=script&lang=js&"
export * from "./todoDetailsTrusteeship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports